<template>
  <div>
    <base-button
      type="primary"
      class="float-right"
      @click="modal = true"
    >{{ $t('operatorAssignees.manageDialog.btnLbl') }}
    </base-button>

    <modal :show.sync="modal"
           modal-classes="modal-dialog-centered modal-lg modal-dialog-scrollable"
           showClose
           @close="resetForm()">
      <template slot="header">
        <h4 class="card-title d-inline">{{ $t('operatorAssignees.manageDialog.title') }}</h4>
      </template>
      <template>
        <div class="row justify-content-end">
          <div class="col-md-6">
            <base-input>
              <el-input
                type="search"
                class="mb-3 search-input"
                prefix-icon="el-icon-search"
                :placeholder="$t('generic.searchInTablePlaceholder')"
                v-model="searchQuery"
                aria-controls="datatables"
              >
              </el-input>
            </base-input>
          </div>
        </div>
        <div class="table-responsive table-wrapper">
          <base-table :data="queriedData" thead-classes="text-primary">
            <template slot="columns" slot-scope="{ columns }">
              <th>{{ $t('system_account.details.username') }}</th>
              <th>{{ $t('operatorAssignees.details.fullName') }}</th>
              <th>{{ $t('system_account.details.email') }}</th>
              <th class="text-right"></th>
            </template>

            <template slot-scope="{ row }">
              <td> {{ row.username }}</td>
              <td>
                {{ row.first_name }} {{ row.last_name }}
              </td>
              <td><span v-if="row.email">{{ row.email }}</span></td>
              <td class="td-actions text-right" v-if="$auth.can({assigned_operator: 'delete'}, 'permissions')">
                <span v-if="isAssigned(row)">
                  <el-tooltip :content="$t('operatorAssignees.assigneeRemoveHint')"
                              effect="light" :open-delay="300" placement="top">
                      <base-button icon round simple class="remove" type="danger" size="sm"
                                   @click.native="handleDelete(row)">
                        <i class="tim-icons icon-simple-remove"></i>
                      </base-button>
                  </el-tooltip>
                </span>
                <span v-else>
                  <el-tooltip :content="$t('operatorAssignees.assigneeAddHint')"
                              effect="light" :open-delay="300" placement="top">
                    <base-button icon round class="remove" type="primary" size="sm" @click.native="handleAdd(row)">
                      <i class="tim-icons icon-simple-add"></i>
                    </base-button>
                  </el-tooltip>
                </span>
              </td>
            </template>
          </base-table>
        </div>
      </template>
    </modal>
  </div>
</template>


<script>
import {BaseTable, Modal} from 'src/components';
import {mapActions, mapState} from "vuex";
import AccountSearchWizard from 'src/pages/Account/AccountSearchWizard'
import Fuse from 'fuse.js';

export default {
  name: 'manage-operator-assignees',
  components: {
    Modal,
    BaseTable,
    AccountSearchWizard,
  },
  props: {
    operatorId: {
      type: String,
      required: false,
    },
  },
  data() {
    return {
      modal: false,
      // modalKey: 1
      searchQuery: '',
      propsToSearch: ['first_name', 'last_name'],
      tableData: [],
      searchedData: [],
      fuseSearch: null,
    }
  },

  computed: {
    ...mapState({
      loading: state => state.system_accounts.loading,
      all: state => state.system_accounts.all,
      assigned: state => state.operator_assignees.data,
      error: state => state.operator_assignees.error,
    }),
    queriedData() {
      let result = this.tableData;
      if (this.searchedData.length > 0) {
        result = this.searchedData;
      }
      return result.slice(this.from, this.to);
    },
  },

  methods: {
    ...mapActions(['LoadSystemAccounts', 'CreateOperatorAssignee', 'DeleteOperatorAssignee']),
    handleAdd: function (row) {
      const payload = {
        systemAccountId: row.id,
        data: {
          operator_id: this.operatorId,
        },
      }
      this.CreateOperatorAssignee(payload).then(() => {
        if (this.error == null) {
          this.$notify({
            type: 'success',
            message: this.$t('operatorAssignees.manageDialog.actionAddSuccess', {
              username: row.username,
              operatorId: this.operatorId
            }),
            icon: 'tim-icons icon-alert-circle-exc'
          })
        }
      });
    },
    handleDelete: function (row) {
      const payload = {
        systemAccountId: row.id,
        operatorId: this.operatorId,
      }
      this.DeleteOperatorAssignee(payload).then(() => {
        if (this.error == null) {
          this.$notify({
            type: 'success',
            message: this.$t('operatorAssignees.manageDialog.actionRemoveSuccess', {
              username: row.username,
              operatorId: this.operatorId
            }),
            icon: 'tim-icons icon-alert-circle-exc'
          })
        }
      });
    },
    isAssigned(row) {
      return this.assigned.some(e => e.id === row.id)
    },
    resetForm: function () {
      // closing dialog
      this.modal = false;
      this.searchQuery = '';
    },
  },
  mounted() {
    this.LoadSystemAccounts()
  },
  watch: {
    /**
     * Searches through the table data by a given query.
     * NOTE: If you have a lot of data, it's recommended to do the search on the Server Side and only display the results here.
     * @param value of the query
     */
    searchQuery(value) {
      let result = this.tableData;
      if (value !== '') {
        result = this.fuseSearch.search(this.searchQuery);
      }
      this.searchedData = result;
    },
    "all"(system_accounts) {
      this.tableData = system_accounts
      // Fuse search initialization.
      this.fuseSearch = new Fuse(this.tableData, {
        keys: this.propsToSearch,
        location: 1,
        threshold: 0.1
      });
    }
  }
}
</script>
<style scoped>
</style>
